import angular from 'angular';

angular.module('AaApp.Opp').constant('entityActionAccessEnum', {
    showHasWarranty: 0,
    showSoldWarranty: 1,
    showDoesntHaveWarranty: 2,
    showUndoSoldWarranty: 3,
    showVehicleNotPaidoff: 4
});
